import React, { useState } from 'react';
import { Tooltip, Box, Typography, IconButton, ClickAwayListener } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

interface InfoTooltipProps {
  title: string;
  description?: string | React.ReactNode;
  formula?: string | React.ReactNode;
  source?: {
    name: string;
    url: string;
  };
  children?: React.ReactNode;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  description,
  formula,
  source,
  children,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Box sx={{ display: 'inline-flex' }}>
        <Tooltip
          open={open}
          onClose={handleClose}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={
            <Box sx={{ maxWidth: 400 }}>
              <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                {title}
              </Typography>
              {description && (
                <Typography variant="caption" component="div" sx={{ mb: 1, lineHeight: 1.6 }}>
                  {description}
                </Typography>
              )}
              {formula && (
                <Box sx={{ mb: 1 }}>
                  {typeof formula === 'string' ? (
                    <Typography variant="caption" component="div" sx={{ mb: 1 }}>
                      <strong>Formula:</strong> {formula}
                    </Typography>
                  ) : (
                    formula
                  )}
                </Box>
              )}
              {source && (
                <>
                  <Typography variant="caption" component="div" sx={{ mt: 0.5, fontWeight: 600 }}>
                    Sources:
                  </Typography>
                  <Typography variant="caption" component="div">
                    • <a href={source.url} target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9', textDecoration: 'underline' }}>
                      {source.name}
                    </a>
                  </Typography>
                </>
              )}
              {children}
            </Box>
          }
          arrow
        >
          <IconButton size="small" sx={{ p: 0.5 }} onClick={handleToggle}>
            <InfoIcon sx={{ fontSize: 18, color: 'primary.main' }} />
          </IconButton>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
};

export default InfoTooltip;
